import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaMapMarkerAlt, FaDollarSign, FaGraduationCap, FaBriefcase, FaAward, FaPhoneAlt, FaEnvelope, FaUserMd, FaCalendarAlt } from 'react-icons/fa';
import StarRatings from 'react-star-ratings';

const DoctorProfileHero = ({ data }) => {
	if (!data) return null;
	const fullName = `Dr. ${[data.firstName, data.lastName].filter(Boolean).join(' ') || 'Doctor'}`;
	const designation = data.designation || 'Medical Professional';
	const specialization = data.specialization || 'General';
	const address = [data.address, data.country].filter(Boolean).join(', ') || data.clinicAddress || '—';
	const price = data.price != null ? `$${Number(data.price)}` : '—';
	const experience = data.experience || '';
	const rating = Number(data.averageRating) || 0;
	const reviewCount = Number(data.reviewCount) || 0;

	return (
		<div className="doctor-hero">
			<div className="doctor-hero__bg" />
			<div className="container">
				<div className="doctor-hero__content">
					<div className="doctor-hero__image-card">
						<div className="doctor-hero__image-wrap">
							{data.img ? (
								<img src={data.img} alt={fullName} className="doctor-hero__image" />
							) : (
								<div className="doctor-hero__image-placeholder">
									<FaUserMd />
								</div>
							)}
							<span className="doctor-hero__badge">
								<FaCheckCircle /> Verified
							</span>
						</div>
					</div>
					<div className="doctor-hero__info-card">
						<div className="doctor-hero__header">
							<div>
								<h1 className="doctor-hero__name">
									{fullName}
									<FaCheckCircle className="doctor-hero__verified-icon" />
								</h1>
								<p className="doctor-hero__designation">{designation}</p>
								<p className="doctor-hero__specialization">{specialization}</p>
							</div>
							<div className="doctor-hero__rating-box">
								<div className="doctor-hero__rating-number">{rating}</div>
								<StarRatings
									rating={rating}
									starRatedColor="#f4c150"
									numberOfStars={5}
									name="rating"
									starDimension="16px"
									starSpacing="2px"
								/>
								<span className="doctor-hero__reviews-count">{reviewCount} {reviewCount === 1 ? 'review' : 'reviews'}</span>
							</div>
						</div>
						<div className="doctor-hero__stats">
							<div className="doctor-hero__stat">
								<FaBriefcase className="doctor-hero__stat-icon" />
								<div>
									<strong>{experience}</strong>
									<span>Experience</span>
								</div>
							</div>
							<div className="doctor-hero__stat">
								<FaCalendarAlt className="doctor-hero__stat-icon" />
								<div>
									<strong>{reviewCount}</strong>
									<span>Reviews</span>
								</div>
							</div>
						</div>
						<div className="doctor-hero__contact">
							{address !== '—' && (
								<div className="doctor-hero__contact-item">
									<FaMapMarkerAlt /> {address}
								</div>
							)}
							{data.phone && (
								<div className="doctor-hero__contact-item">
									<FaPhoneAlt /> {data.phone}
								</div>
							)}
							<div className="doctor-hero__contact-item">
								<FaEnvelope /> support@specialisthub.co.zw
							</div>
						</div>
						<div className="doctor-hero__actions">
							<Link to={`/booking/${data.id}`} className="doctor-hero__book-btn">
								Book appointment
							</Link>
							<button className="doctor-hero__chat-btn" onClick={() => window.Tawk_API && window.Tawk_API.toggle()}>
								Send message
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DoctorProfileHero;
